import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";
import { ErrorBoundary } from "react-error-boundary";

import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { RouterInfo } from "./routes";
import ErrorFallback from "./components/ErrorFallback";

const Routers = createBrowserRouter(RouterInfo);

const errorHandler = (error, errorInfo) => {
  console.error("Error caught by ErrorBoundary:", error, errorInfo);
};

console.log("ErrorFallback", ErrorFallback);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={errorHandler}
      onReset={() => {
        window.location.href = "/";
      }}
    >
      <RecoilRoot>
        <RouterProvider router={Routers} />
      </RecoilRoot>
    </ErrorBoundary>
  </React.StrictMode>,
);

reportWebVitals();
